import React from "react";

function SummaryBar({ contractors }) {
  const expired = contractors.filter(c => c.daysRemaining <= 0).length;
  const within7 = contractors.filter(c => c.daysRemaining > 0 && c.daysRemaining <= 7).length;
  const within30 = contractors.filter(c => c.daysRemaining > 7 && c.daysRemaining <= 30).length;

  return (
    <div style={{ background:"#fff", border:"0.5px solid #e0e0df", borderRadius:"8px", padding:"14px 20px", marginBottom:"20px", display:"flex", alignItems:"center" }}>
      <div style={{ display:"flex", alignItems:"center", gap:"8px", paddingRight:"16px", borderRight:"0.5px solid #e0e0df", marginRight:"16px" }}>
        <span style={{ fontSize:"18px", fontWeight:700, color:"#18073a" }}>{contractors.length}</span>
        <span style={{ fontSize:"12px", fontWeight:500, color:"#79749c" }}>contractors</span>
      </div>
      {expired > 0 && (
        <div style={{ display:"flex", alignItems:"center", gap:"6px", padding:"0 16px", borderRight:"0.5px solid #e0e0df" }}>
          <span style={{ width:"7px", height:"7px", borderRadius:"50%", background:"#82162d", display:"inline-block" }}></span>
          <span style={{ fontSize:"12px", fontWeight:600, color:"#82162d" }}>{expired} expired</span>
        </div>
      )}
      {within7 > 0 && (
        <div style={{ display:"flex", alignItems:"center", gap:"6px", padding:"0 16px", borderRight:"0.5px solid #e0e0df" }}>
          <span style={{ width:"7px", height:"7px", borderRadius:"50%", background:"#cc8943", display:"inline-block" }}></span>
          <span style={{ fontSize:"12px", fontWeight:600, color:"#cc8943" }}>{within7} expiring within 7 days</span>
        </div>
      )}
      {within30 > 0 && (
        <div style={{ display:"flex", alignItems:"center", gap:"6px", padding:"0 16px" }}>
          <span style={{ width:"7px", height:"7px", borderRadius:"50%", background:"#cc8943", display:"inline-block", opacity:0.5 }}></span>
          <span style={{ fontSize:"12px", fontWeight:500, color:"#79749c" }}>{within30} expiring within 30 days</span>
        </div>
      )}
    </div>
  );
}

export default SummaryBar;
